var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('div',{staticClass:"more"},[_c('div',{staticClass:"more-tips"},[_vm._v("更多详细内容，请登录壁虎看看网页端查看")]),_c('div',{staticClass:"more-src"},[_vm._v("bihukankan.com")])])])}]

export { render, staticRenderFns }